<template>
  <div class="occasion-filter">
        <div class="title-container">
            <p class="title">Occasion <span v-if="selectedOccasion.length > 0">({{selectedOccasion.length}})</span></p>
            <p @click="collapse" class="icon">{{plusIcon}}</p>
        </div>
        <div v-if="!collapsed" class="radio-container">
            <div class="radio-button" v-for="occasion of currentOccasions" :key="occasion.title">
                <input @change="setSelectedOccasion(occasion.title)" v-model="selectedOccasion" :value="occasion.title" type="checkbox">
                <p>{{occasion.title}}</p>
            </div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
export default {
    mixins: [smoothReflow],
    data() {
        return{
            collapsed: false,
        }
    },
    props:{
        occasions: Array,
    },
    computed: {
        selectedOccasion: {
            get(){ return this.$store.state.selectedOccasion},
            set(value){
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Build A Box',
                    eventAction: 'Filter Occasion',
                    eventLabel: value
                });
            }
        },
        currentOccasions(){
            return this.occasions;
        },
        plusIcon(){
            return this.collapsed == true ? '+' : '-';
        }
    },
    methods: {
        collapse(){
            this.collapsed = !this.collapsed;
        },
        setSelectedOccasion(value){
            this.$store.commit('setSelectedOccasion', value )
        },
    },
    mounted(){
        this.$smoothReflow()
    },
}
</script>

<style scoped>
.occasion-filter{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    box-shadow: inset 0px -1px 0px #E6E8EC;
}

.icon{
    cursor: pointer;
}

.title-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 2% 0%;
}
.title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
}

.radio-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0% 0% 3% 0%;
    width: 100%;
    overflow: hidden;
}

.radio-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 1% 0%;
}

.radio-button input{
    background-color: #FFFFFF;
    border: 1px solid #E8E1F2;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 40px;
    height: unset !important;
}

.radio-button p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.43;
    color: #0F0C38;
}

@media screen and (max-width: 767px){
    .title{
        font-size: 1.2rem;
    }

    .icon{
        font-size: 2rem;
    }

    .radio-button p{
        font-size: 1rem;
    }
}
</style>